import type { ComponentType } from 'react';
import type { ActionDialogProps } from './types';
import { AchIntakeDialog } from './dialogs/AchIntakeDialog';
import { AchChargeDialog } from './dialogs/AchChargeDialog';
import { AchChargeWithIntakeDialog } from './dialogs/AchChargeWithIntakeDialog';
import { AchApproveDialog } from './dialogs/AchApproveDialog';
import { AchRejectDialog } from './dialogs/AchRejectDialog';
import { AchVerifyDialog } from './dialogs/AchVerifyDialog';

export const ACTION_DIALOG_REGISTRY: Record<string, ComponentType<ActionDialogProps>> = {
  AchIntakeDialog,
  AchChargeDialog,
  AchChargeWithIntakeDialog,
  AchApproveDialog,
  AchRejectDialog,
  AchVerifyDialog,
};
